import { rejectL } from "fxjs/es";
export const removeEl = (self, el) => {
  self._checkNoProcessingTask();
  const working_layer_el = self._getWorkingLayerElThrowable();
  const working_layer = self._getWorkingLayerThrowable();
  const selection = self._getSelectionThrowable();
  if (!working_layer.getIsChildGraphicsEl(el)) {
    throw new Error(`layer 엘리먼트의 자식 엘리먼트만 삭제할 수 있습니다.`);
  }
  const selected_el_set = selection.getSelectedEls();
  if (selected_el_set.has(el)) {
    selection.setSelectedEls(
      rejectL((selected_el) => selected_el === el)(selected_el_set)
    );
  }
  working_layer_el.removeChild(el);
  working_layer_el.dispatchEvent(
    new CustomEvent(`@mp/sticker-editor/remove`, {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        el,
      },
    })
  );
};
